export const GET_ENGAGEMENTS = "GET_ENGAGEMENTS";
export const GET_ENGAGEMENT_BY_ID = "GET_ENGAGEMENT_BY_ID";
export const UPDATE_ENGAGEMENT = "UPDATE_ENGAGEMENT";
export const DELETE_ENGAGEMENT = "DELETE_ENGAGEMENT";
export const CREATE_ENGAGEMENT = "CREATE_ENGAGEMENT";
